<template>
  <NavigationComponent>
    <Standardfolie title="Neue Vue App erstellen">
      <p>Voraussetzung für Vue ist NodeJS mit npm</p>
      <p>Vue lässt sich dann folgendermaßen installieren:</p>
      <VCode content="npm install vue -g"></VCode>
      <p>Neue Vue Apps lassen sich z. B. per Terminal erstellen</p>
      <VCode content="vue create appname"></VCode>
      <p>Alternativ lässt sich die Vue UI benutzen:</p>
      <VCode content="vue ui"></VCode>
      <p>Modul hinzufügen:</p>
      <VCode content="vue add modulename"></VCode>
      <p>empfehlenswerte Module: Router, Vuex, Vuetify</p>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "../components/NavigationComponent";
import Standardfolie from "../components/Standardfolie";
import VCode from "../components/VCode";
export default {
  name: "NeueVueApp",
  components: { Standardfolie, NavigationComponent, VCode }
};
</script>

<style scoped></style>
